import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePageStore = defineStore('page', () => {
    const hideLanguageSelection = ref(false);
    const craftEntryId = ref(null);

    const setHideLanguageSelection = (value: boolean) => {
        hideLanguageSelection.value = !!value;
    };

    const setCraftEntryId = (value) => {
        craftEntryId.value = value ?? null;
    };

    return {
        hideLanguageSelection,
        setHideLanguageSelection,
        craftEntryId,
        setCraftEntryId,
    };
});
